import * as React from 'react';
import { useMemo } from 'react';

import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { IQuest } from '../loyalty-quest/types';
import { isQuestActivated, isQuestCompleted, isStepCompleted } from '../loyalty-quest/utils';

import { QuestBadgeText } from './styled';

interface IQuestBadgeProps {
  quest: IQuest;
}

export const QuestBadge = ({ quest }: IQuestBadgeProps) => {
  const status = quest.status;

  const challengeHasSomeProgress = useMemo(
    () => !!quest?.steps?.some(step => isStepCompleted(step.status)),
    [quest?.steps]
  );

  const isQuestActivedWithProgress = isQuestActivated(status) && challengeHasSomeProgress;

  const text = useMemo(() => {
    if (isQuestCompleted(status)) {
      return t('completed');
    }

    if (isQuestActivedWithProgress) {
      return t('inProgress', 'In Progress');
    }

    return t('challengeActivated');
  }, [isQuestActivedWithProgress, status]);

  const textColor = primitive.$bbqBrown;
  const backgroundColor = {
    backgroundColor: primitive.$white,
  };

  return (
    <Box style={[styles.container, backgroundColor]}>
      <Typography variant="copyTwo" color={textColor}>
        {text}
      </Typography>
      <QuestBadgeText variant="copyTwo"></QuestBadgeText>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: spacing.$1,
    borderRadius: 3,
    alignItems: 'center',
  },
});
